import React from 'react';
import styles from './Loader.module.scss';

const Loader = () => {
  return (
  <div className={styles.Loader}>
    <div id="global-loaders" style={{display: 'none'}}>
        <img src={require("../../assets/images/loader.gif").default} className="loader-img" alt="Loading...."/>
    </div>
    
  </div>
)
  };

export default Loader;
